// extracted by mini-css-extract-plugin
export default {"card":"TaskReorderBtn_card__S-sNw","option":"TaskReorderBtn_option__xKFM3","disabled":"TaskReorderBtn_disabled__I9TJ8"};